<template>
  <c-main>
    <c-row>
      <c-col md="12">
        <form @submit.prevent="submit">
          <c-panel title="Action Settings">
            <c-form-field label="Name*">
              <c-form-input
                v-bind:autocomplete="'label'"
                v-bind:status="$v.action.key.$error ? 'danger' : ''"
                v-model="action.key"
              ></c-form-input>
              <span
                v-if="action.submitted && !$v.action.key.required"
                class="form-help u-color-danger"
              >Label is required.</span>
            </c-form-field>

            <c-form-field label="Code*">
              <c-form-input
                v-bind:autocomplete="'name'"
                v-bind:status="$v.action.value.$error ? 'danger' : ''"
                v-model="action.value"
              ></c-form-input>
              <span
                v-if="action.submitted && !$v.action.value.required"
                class="form-help u-color-danger"
              >Name is required.</span>
            </c-form-field>

            <div class="u-text-right" slot="footer">
              <c-button type="primary" smart>Save</c-button>
            </div>
          </c-panel>
          
        </form>
      </c-col>
    </c-row>
  </c-main>
</template>

<script>
import FlatPickr from "cover/vendors/flatpickr";
import { required, email, minLength } from "vuelidate/lib/validators";
import { mapState } from "vuex";

export default {
  components: {
    [FlatPickr.name]: FlatPickr,
  },
  data() {
    return {
      action: {
        value: "",
        key: "",
        submitted: false,
      },
    };
  },
  validations: {
    action: {
      key: { required },
      value: { required }
    },
  },
  computed: {

  },
  created() {
    let _this = this;
    if (this.$route.params && this.$route.params.id) {
      this.$axios
        .get(
          _this.$cfg.API_URL + "/settings/action?_id=" + this.$route.params.id
        )
        .then((res) => {
          if (res.data.status == "ok") {
            this.action = res.data.data.action;
          }
        });
    }
  },
  methods: {
    submit: function () {
      let _this = this;
      this.action.submitted = true;
      this.$v.action.$touch();

      // if its still pending or an error is returned do not submit
      if (this.$v.action.$pending || this.$v.action.$error) return;

      const vm = this.$toast.loading("Saving...");

      vm.show();
      this.$axios
        .post(_this.$cfg.API_URL + "/settings/action", this.action)
        .then((res) => {
          if (res.data.status == "ok") {
            this.$notify({
              type: "success",
              title: "Action is saved",
              closeable: true,
              duration: 5000,
            });
            vm.hide();
            this.$router.push({ name: "Settings" });
            this.$store.dispatch('config')
          }
        })
        .catch((err) => {
          this.$notify({
            type: "danger",
            title: "Server error",
            content: "err",
            closeable: true,
            duration: 5000,
          });
          vm.hide();
        });
    },
  },
};
</script>